import styled from "styled-components";

export const VideoContainer= styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  flex-direction: column;
  //max-width: 600px;
`

export const VideoImg= styled.img`
  //@media (max-width: 600px) {
    width: 100%;
    height: 100%;
  //  object-fit: contain;
  //}
`

export const Microfone= styled.div`
  position: absolute;
  top: 0;
`

export const CloseButton= styled.div`
  position: absolute;
  //background-color: white;
  top: 0;
  right: 0;
`
